// Haversine distance in kilometres between two {lat, lng}-ish points.
export function distanceKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

export function placeDistanceKm(userLoc, place) {
  if (!userLoc || place.latitude == null || place.longitude == null) return null;
  return distanceKm(userLoc.lat, userLoc.lng, place.latitude, place.longitude);
}

export function formatDistance(km) {
  if (km == null) return '';
  if (km < 1) return `${Math.round(km * 1000)} m`;
  return `${km < 10 ? km.toFixed(1) : Math.round(km)} km`;
}

// Wrap navigator.geolocation in a promise. Rejects with a friendly message.
export function getCurrentPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Location is not supported on this device.'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      (err) => {
        reject(new Error(
          err.code === err.PERMISSION_DENIED
            ? 'Location permission denied — enable it in your browser settings.'
            : 'Couldn’t get your location. Try again.',
        ));
      },
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 },
    );
  });
}
